import script from "./GPTLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./GPTLoading.vue?vue&type=script&setup=true&lang=js"

import "./GPTLoading.vue?vue&type=style&index=0&id=0bfe856c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bfe856c"]])

export default __exports__